const CACHE_NAME = 'agent-icons-v1';

export const getCachedImage = async (url: string): Promise<string> => {
  if (!url) return '';

  try {
    const cache = await caches.open(CACHE_NAME);
    const cachedResponse = await cache.match(url);

    if (cachedResponse) {
      const blob = await cachedResponse.blob();
      return URL.createObjectURL(blob);
    }

    const response = await fetch(url, { mode: 'cors' });
    if (response.ok) {
      cache.put(url, response.clone());
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    }

    return url;
  } catch (error) {
    return url;
  }
};

export const preloadImages = async (urls: string[]): Promise<void> => {
  await Promise.all(urls.filter(Boolean).map(getCachedImage));
};

export const clearImageCache = async (): Promise<void> => {
  await caches.delete(CACHE_NAME);
};
